// src/pages/QuotationView.js
import React from 'react';
import QuotationDetail from '../components/quotation/QuotationDetail';

function QuotationView() {
  return (
    <div className="quotation-view-page">
      <QuotationDetail />
    </div>
  );
}

export default QuotationView;
